import { useEffect, useRef } from 'react'

import { STOPS, type Stop, type StopId } from '@/lib/demos'
import { cn } from '@/lib/utils'

export function TourTabs({ current, onSelect }: { current: Stop; onSelect: (id: StopId) => void }) {
  const activeRef = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' })
  }, [current.id])

  return (
    <nav
      aria-label="Playgrounds"
      className="flex flex-none gap-1 overflow-x-auto border-b border-border px-2 py-1"
    >
      {STOPS.map((s) => {
        const active = s.id === current.id
        return (
          <button
            key={s.id}
            ref={active ? activeRef : undefined}
            type="button"
            aria-current={active ? 'step' : undefined}
            title={s.title}
            onClick={() => onSelect(s.id)}
            className={cn(
              'flex min-h-9 shrink-0 items-center gap-1.5 rounded-md px-3 text-xs font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none',
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <span className="font-mono text-[10px] tabular-nums opacity-70">
              {String(s.n).padStart(2, '0')}
            </span>
            <span>{s.shortTitle}</span>
          </button>
        )
      })}
    </nav>
  )
}
